import React from "react";
import { Box } from "@mui/material";
import PersonOutlineOutlined from "@mui/icons-material/PersonOutlineOutlined";
import { SectionHeader } from "../layout/SectionHeader";
import { FormField } from "../fields/FormField";
import { ProfileFormGrid } from "../ProfileFormGrid";
import { profileSubsectionShellSx } from "../../profileFieldStyles";

export function DatiReferente({ vendorForm, fieldErrors, onChange, readOnly = false }) {
  const v = vendorForm ?? {};
  const err = fieldErrors ?? {};

  return (
    <Box sx={profileSubsectionShellSx}>
      <SectionHeader title="Referente" icon={PersonOutlineOutlined} />
      <ProfileFormGrid>
        <FormField
          name="nomeReferente"
          value={v.nomeReferente}
          errorMessage={err.nomeReferente}
          onChange={onChange}
          readOnly={readOnly}
        />
        <FormField
          name="cognomeReferente"
          value={v.cognomeReferente}
          errorMessage={err.cognomeReferente}
          onChange={onChange}
          readOnly={readOnly}
        />
        <FormField
          name="emailReferente"
          value={v.emailReferente}
          errorMessage={err.emailReferente}
          onChange={onChange}
          readOnly={readOnly}
        />
        <FormField
          name="telefonoReferente"
          value={v.telefonoReferente}
          errorMessage={err.telefonoReferente}
          onChange={onChange}
          readOnly={readOnly}
        />
      </ProfileFormGrid>
    </Box>
  );
}
